var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPump = function SvgPump(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pump_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263F54",
    d: "M20 12c0-6.627 5.373-12 12-12h16c6.627 0 12 5.373 12 12v16c0 6.627-5.373 12-12 12H32c-6.627 0-12-5.373-12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M21 12c0-6.075 4.925-11 11-11h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H32c-6.075 0-11-4.925-11-11z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.261,
    d: "M42.612 27.657c.273-.342 2.838-1.061 1.892-4.657-.925-3.517.316-6.25 1.892-5.209"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.613,
    height: 2.522,
    x: 32.523,
    y: 11.261,
    stroke: "#fff",
    strokeWidth: 1.261,
    rx: 1.261
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.045,
    height: 2.522,
    x: 36.307,
    y: 11.261,
    stroke: "#fff",
    strokeWidth: 1.261,
    rx: 1.261
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.261,
    d: "M37.567 13.784h2.523v12.612h-2.523z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.567,
    height: 2.522,
    stroke: "#fff",
    strokeWidth: 1.261,
    rx: 1.261,
    transform: "matrix(1 0 0 -1 35.045 28.919)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.261,
    d: "M46.397 17.567c0-.696.564-1.26 1.26-1.26h1.262v2.522h-1.261a1.26 1.26 0 0 1-1.261-1.262Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.261,
    d: "M31.262 28.919h15.135"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pump_svg__a",
    width: 80,
    height: 80,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 5,
    result: "effect1_dropShadow_4794_151127"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4794_151127"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 6,
    result: "effect2_dropShadow_4794_151127"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4794_151127",
    result: "effect2_dropShadow_4794_151127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4794_151127",
    result: "shape"
  })))));
};
export default SvgPump;